import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const CTASection = () => {
  const { t } = useTranslation("translation");
  const navigate = useNavigate();

  return (
    <section className="cta-section">
      <div className="cta-container">

        <h2 className="cta-heading">
          {t("cta.heading")}
        </h2>

        <p className="cta-description">
          {t("cta.description")}
        </p>

        <div className="cta-buttons">

          <button className="cta-btn cta-btn-primary" onClick={() => navigate('/sign-up')}>
            {t("cta.startTrial")}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" />
            </svg>
          </button>
{/* 
          <button className="cta-btn cta-btn-secondary">
            {t("cta.bookDemo")}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" />
            </svg>
          </button> */}

        </div>
      </div>
    </section>
  );
};

export default CTASection;
